import React from "react";
import styles from "./index.module.scss";
const NotiFicationContainerBox = ({ countNumber, data }) => {
  return (
    <div
      className={`${styles.NotiFicationContainerBox} mb-3 d-flex align-items-center gap-3`}
    >
      <div
        className={`${styles.NumberCount} rounded-circle d-flex align-items-center justify-content-center`}
      >
        {countNumber}
      </div>
      <img
        src="/assets/temp/winner.png"
        className="image-fluid object-fit-contain"
        width={"56px"}
        height={"56px"}
      />

      <div className={`${styles.Content} d-flex flex-column`}>
        <p className={styles.NotiFicationTitle}>{data?.name}</p>
        <p className={styles.NotiFicationSubTitle}>{`${data?.total_coins} points`}</p>
      </div>
    </div>
  );
};

export default NotiFicationContainerBox;
